export default "__VITE_ASSET__fiylzyES__"